<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    errors: { type: [Array, Object], default: () => ({}) },
});

const emit = defineEmits(['update:modelValue', 'touched']);

const model = computed({
    get: () => props.modelValue || {},
    set: (val) => emit('update:modelValue', val),
});

const errorsFor = useFieldErrors(props).errorsFor;

const setNumber = (key, value) => {
    emit('touched');

    let finalValue = null;
    if (value !== '' && value !== null) {
        finalValue = Number(value);
    }

    model.value = {
        ...model.value,
        [key]: finalValue,
    };
};

const jointAgeGapLimit = computed({
    get: () => model.value.joint_age_gap_limit ?? '',
    set: (val) => setNumber('joint_age_gap_limit', val),
});
</script>

<template>
<div class="grid md:grid-cols-2 gap-4">
    <StyledInput
        v-model="jointAgeGapLimit"
        :label="$t('label.joint_age_gap_limit')"
        name="joint_age_gap_limit"
        type="number"
        :error-messages="errorsFor('joint_age_gap_limit')" />
</div>
</template>
